import { commonFunctions } from "../_utilities/commonFunctions"
import { config } from "../config"

export const correspondanceService = {
    getCorrespondanceDetails,
    createCorrespondanceDetail,
    deleteCorrespondanceDetail,
    updateCorrespondanceDetail
}

function getCorrespondanceDetails(id) {
    const requestOptions = commonFunctions.getRequestOptions(
        "GET"
    )
    return fetch(
        `${config.localApiUrl}/api/correspondence/${id}`,
        requestOptions
    ).then((response) => response.json())
}

function createCorrespondanceDetail(formData) {
    const requestOptions = {
        method: "post",
        body: formData
    };
    return fetch(
        `${config.localApiUrl}/api/createCorrespondence`,
        requestOptions,
    ).then((response) => response.json())
}

function deleteCorrespondanceDetail(id) {
    const requestOptions = commonFunctions.getRequestOptions(
        "DELETE"
    )
    return fetch(
        `${config.localApiUrl}/api/deleteCorrespondence/${id}`,
        requestOptions,
    ).then((response) => response.json())
}

function updateCorrespondanceDetail(formData, id) {
    const requestOptions = {
        method: "PUT",
        body: formData
    }
    return fetch(
        `${config.localApiUrl}/api/updateCorrespondence/${id}`,
        requestOptions,
    ).then((response) => response.json())
}